import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

var vueSmoothScroll = require("vue-smoothscroll");
Vue.use(vueSmoothScroll);

const combinationsJson = require("../data/combinations");
const buttonsJson = require("../data/buttons");
const contentJson = require("../data/contents");

const buttonsModel = buttonsJson;

export default new Vuex.Store({
  state: {
    history: [],
    pageContents: [],
    buttonsModel,
    lock: false,
    scrollTrigger: 0,
    currentLayer: null,
    bodyHeight: 0,
  },
  getters: {
    history: state => state.history,
    pageContents: state => state.pageContents,
    scrollTrigger: state => state.scrollTrigger,
    currentLayer: state => state.currentLayer,
  },
  mutations: {
    UPDATE_HISTORY(state, payload) {
      if (payload.clusterIndex < state.history.length - 1) {
        state.history = state.history.slice(0, payload.clusterIndex + 1);
        state.history.push(payload.id);
      } else {
        state.history.push(payload.id);
      }
    },
    SET_BUTTON_TO_CLICKED(state, id) {
      state.buttonsModel[id].clicked = true;
    },
    RESTART(state) {
      state.history = ["start"];
      state.pageContents = [];
    },
    UPDATE_CONTENTS(state) {
      const combination =
        combinationsJson[state.history[state.history.length - 1]];

      const buttons = combination.buttons.reduce((acc, buttonId) => {
        acc[buttonId] = buttonsModel[buttonId];
        return acc;
      }, {});

      const contents = combination.contents.map(
        contentId => contentJson[contentId]
      );

      if (state.history.length !== state.pageContents.length + 1) {
        state.pageContents = state.pageContents.slice(
          0,
          state.history.length - 1
        );
        setTimeout(() => state.pageContents.push({ buttons, contents }), 300);
      } else {
        state.pageContents.push({ buttons, contents });
      }
    },
    LOCK_APP(state) {
      state.lock = true;
    },
    UNLOCK_APP(state) {
      state.lock = false;
    },
    SCROLLTRIGGER(state) {
      // count up to trigger reactivity change
      state.scrollTrigger += 1;
    },
    CHECKHEIGHT(state) {
      state.bodyHeight += 1;
    },
    CURRENT_LAYER(state, layer) {
      state.currentLayer = layer;

      if (layer) {
        document.body.dataset.layer = layer;
      } else {
        document.body.removeAttribute("data-layer");
      }
    },
  },
  actions: {
    onButtonClick({ commit, dispatch }, payload) {
      commit("SET_BUTTON_TO_CLICKED", payload.id);
      dispatch("updateHistory", {
        id: payload.action,
        clusterIndex: payload.clusterIndex,
      });
    },
    updateHistory({ commit }, { id, clusterIndex = 0 }) {
      commit("UPDATE_HISTORY", { id, clusterIndex });
      commit("UPDATE_CONTENTS");
    },
    restart({ commit }) {
      commit("RESTART");
      commit("UPDATE_CONTENTS");
    },
    lockApp({ commit }) {
      commit("LOCK_APP");
    },
    unlockApp({ commit }) {
      commit("UNLOCK_APP");
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js